import { Component, OnChanges, Input } from '@angular/core';

import { FormatService } from '@services/format.service';

import { MonitoringResultGraph } from '@classes/monitoring/monitoring-result-graph';
import { MonitoringResultData } from '@classes/monitoring/monitoring-result-data';

@Component({
  selector: 'app-monitoring-graph-table',
  templateUrl: './monitoring-graph-table.component.html',
  styleUrls: ['./monitoring-graph-table.component.scss']
})
export class MonitoringGraphTableComponent implements OnChanges {

    @Input() graph: MonitoringResultGraph;

    labels: string[];
    values: string[];

    datas: MonitoringResultData[] = [];

    constructor (private formatSrv: FormatService) {}

    ngOnChanges (): void {
        const datas = this.graph.datas.sort((a, b) => b.value - a.value);

        this.labels = datas.map(i => i.label);

        this.values = [];
        if (this.graph.format === 'percent') {
            const sum = datas.map(i => i.value).reduce((a, b) => a + b, 0);
            if (sum === 0) {
                this.values = [];
            } else {
                this.values = datas.map(i => this.formatSrv.formatPercent(i.value / sum));
            }
        } else {
            this.values = datas.map(i => "" + i.value);
        }
    }

}
